import { App } from "../NodeSidebar/AppTypeahead/useAppSearchData";

export const popularApps: App[] = [
  {
    id: 1498,
    canonicalId: "0d71fb90-f233-4ce0-bdb1-3a2c887dfadf",
    serviceId: "1498",
    slug: "google-sheets",
    name: "Google Sheets",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "GoogleSheetsV2CLIAPI@2.3.0" },
  },
  {
    id: 20,
    canonicalId: "e6e814c3-04c6-4329-828a-9184e44d623a",
    serviceId: "20",
    slug: "gmail",
    name: "Gmail",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "GoogleMailV2CLIAPI@2.0.2" },
  },
  {
    id: 884,
    canonicalId: "ca83afc5-ee9a-470d-b577-e7f8fd555b67",
    serviceId: "884",
    slug: "slack",
    name: "Slack",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "SlackCLIAPI@1.7.0" },
  },
  {
    id: 36,
    canonicalId: "d74234df-0045-436e-bd5b-ee577e74e6b8",
    serviceId: "36",
    slug: "google-calendar",
    name: "Google Calendar",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "GoogleCalendarCLIAPI@1.5.0" },
  },
  {
    id: 69,
    canonicalId: "cd919e3d-bee3-4759-a027-eaa28a71aac5",
    serviceId: "69",
    slug: "google-drive",
    name: "Google Drive",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "GoogleDriveCLIAPI@1.8.5" },
  },
  {
    id: 12273,
    canonicalId: "134f999e-550a-434b-9dab-51c81faab3f4",
    serviceId: "12273",
    slug: "notion",
    name: "Notion",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "NotionCLIAPI@2.14.4" },
  },
  {
    id: 62,
    canonicalId: "1e4fcbf4-d80b-4ec3-b33b-c085f1ecbbaa",
    serviceId: "62",
    slug: "hubspot",
    name: "HubSpot",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "HubSpotCLIAPI@1.10.3" },
  },
  {
    id: 32800,
    canonicalId: "fbd01cba-597f-4700-b83b-072ccbd2b701",
    serviceId: "32800",
    slug: "google-forms",
    name: "Google Forms",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "GoogleFormsCLIAPI@1.0.6" },
  },
  {
    id: 6,
    canonicalId: "1db199f1-6e48-47c6-a4e6-2a2c2b7a1b1c",
    serviceId: "6",
    slug: "mailchimp",
    name: "Mailchimp",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "MailchimpCLIAPI@1.13.3" },
  },
  {
    id: 3535,
    canonicalId: "53f87517-7488-459c-82fa-31bd53868756",
    serviceId: "3535",
    slug: "facebook-lead-ads",
    name: "Facebook Lead Ads",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "FacebookLeadsCLIAPI@1.1.6" },
  },
  {
    id: 3341,
    canonicalId: "e07458d5-5988-479c-a85e-a716d67adcfa",
    serviceId: "3341",
    slug: "calendly",
    name: "Calendly",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "CalendlyCLIAPI@2.3.3" },
  },
  {
    id: 730,
    canonicalId: "c91cc1ba-d8fb-4aaa-b71a-a325f7705f78",
    serviceId: "730",
    slug: "typeform",
    name: "Typeform",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: { id: "TypeformCLIAPI@1.0.33" },
  },
];

export const zapierApps = [
  {
    id: 38635,
    canonicalId: "742f1360-3775-41fd-9c7c-c82f106a0af1",
    serviceId: "38635",
    slug: "zapier-tables",
    name: "Tables",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: {
      id: "TableCLIAPI@1.16.6",
    },
  },
  {
    id: 38333,
    canonicalId: "1129b0d3-c561-48ad-98ca-dc9e2e69fb8d",
    serviceId: "38333",
    slug: "interfaces",
    name: "Interfaces",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: {
      id: "InterfacesCLIAPI@1.8.15",
    },
  },
  {
    id: 40105,
    canonicalId: "700d29e0-25d8-4e54-bed7-4943ff23aa77",
    serviceId: "40105",
    slug: "zapier-chatbots",
    name: "Chatbots",
    images: {
      url_16x16:
        "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32:
        "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64:
        "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128:
        "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128",
    },
    currentImplementation: {
      id: "ChatbotsCLIAPI@1.2.1",
    },
  },
];
